import Lang from '@/lang';

export default {
    data: function () {
        return {
            Lang: Lang
        }
    },
    computed: {
        sharedLayoutDirection(){
            if (Lang.getLocale() == 'en'){
                return 'ltr';
            }
            return 'rtl';
        }
    }
}
